import React from 'react';
import PropTypes from 'prop-types';
import {
  ItemContainer,
  ControlledSubstanceIndicator,
  MedicationTitleContainer,
  MedicationTitle,
  MedicationIconWrapper,
  DescriptionWrapper,
  Divisor,
  BuyMedicationButton,
  BuyMedicationTitle,
  MedicationActivePrinciple,
} from './styles';
import { Icon } from '~/shared/components';
import { Theme } from '~/styles';
import MevoModal from '../mevoModal';
import api from '~/services/api';

const MedicineItem = ({
  id,
  isControlled,
  description,
  medicine,
  mevoExternalId,
  mevoToken,
  prescriptionData,
  mevoCallback,
  activePrinciple,
  ...rest
}) => {
  const [showMevoModal, setShowMevoModal] = React.useState(false);
  const useMevo = Boolean(process.env.REACT_APP_USE_MEVO);

  return (
    <ItemContainer {...rest}>
      <MevoModal
        show={showMevoModal}
        onClose={() => setShowMevoModal(false)}
        onConfirm={mevoCallback}
      />
      {isControlled && (
        <ControlledSubstanceIndicator data-testid="controlledMedication">
          <div>Medicamento controlado</div>
        </ControlledSubstanceIndicator>
      )}
      <MedicationTitleContainer>
        <MedicationIconWrapper>
          <Icon
            data-testid="icon"
            name="controlled_prescription"
            color={isControlled ? 'danger' : 'yellow1'}
            size={Theme.iconSizes.xSmall}
          />
        </MedicationIconWrapper>
        <div style={{ width: '90%' }}>
          <MedicationTitle data-testid="medicine">{medicine}</MedicationTitle>
          {activePrinciple && (
            <MedicationActivePrinciple>
              {activePrinciple}
            </MedicationActivePrinciple>
          )}
          {!!description && <Divisor />}
        </div>
      </MedicationTitleContainer>
      {!!description && (
        <DescriptionWrapper data-testid="description">
          {description}
        </DescriptionWrapper>
      )}
      {prescriptionData &&
        mevoExternalId &&
        !!prescriptionData?.patient?.phone &&
        useMevo && (
          <BuyMedicationButton
            data-testid="description"
            onClick={() => {
              mevoToken
                ? window.open(`${process.env.REACT_APP_MEVO_URL}/${mevoToken}`)
                : setShowMevoModal(true);
            }}
          >
            <BuyMedicationTitle>Comprar medicamento</BuyMedicationTitle>
          </BuyMedicationButton>
        )}
    </ItemContainer>
  );
};

MedicineItem.propTypes = {
  id: PropTypes.number,
  isControlled: PropTypes.bool,
  medicine: PropTypes.string.isRequired,
  description: PropTypes.string,
  mevoExternalId: PropTypes.string,
  mevoToken: PropTypes.string,
  prescriptionData: PropTypes.any,
  mevoCallback: PropTypes.func,
  activePrinciple: PropTypes.string,
};

MedicineItem.defaultProps = {
  id: null,
  isControlled: true,
  description: null,
  mevoExternalId: null,
  mevoToken: null,
  prescriptionData: null,
  mevoCallback: null,
  activePrinciple: null,
};

export default MedicineItem;
